import { providerPluginEDR } from "@rce/rce-edr-client-sdk";
import Analytics from "analytics";
import getConfig from "next/config";

import packageJson from "../../../package.json";

const { publicRuntimeConfig } = getConfig();

const isAnalyticsAllowed = () => {
  if (typeof window === "undefined" || !window.analyticsAllowed?.()) {
    return false;
  }
  return true;
};

let analyticsInstance: ReturnType<typeof Analytics> | null = null;
export function getAnalyticsClient() {
  return analyticsInstance;
}
function initAnalyticsClient() {
  if (!isAnalyticsAllowed()) return;
  const plugins = [];

  const edrUrl = publicRuntimeConfig.EDR_URL;
  const edrClientId = publicRuntimeConfig.EDR_CLIENT_ID;

  if (edrUrl && edrClientId) {
    plugins.push(
      providerPluginEDR({
        clientId: edrClientId,
        apiBaseUrl: edrUrl,
        platform: "web",
        channel: "rceEvents",
        enabled: true,
        appContext: {
          name: "fe-page-builder",
          version: packageJson.version,
        },
      })
    );
  }

  analyticsInstance = Analytics({
    app: "fe-page-builder",
    plugins,
  });

  analyticsInstance.page();
}

export { initAnalyticsClient };
